import { Navigate } from "react-router-dom";

import { navigationV2 } from "@src/shared/navigation/v2";

export function DashboardV2Route() {
  return <Navigate to={navigationV2.visits()} replace />;
}
